



















import Vue from 'vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'Tabs',
  props: {
    tabsType: {
      type: String,
      default: 'check',
      validator (value: string) {
        return ['check', 'result'].includes(value)
      }
    }
  },
  data () {
    return {
      tab: 0
    }
  },
  methods: {
    ...mapActions('results', ['updateCheckType', 'updateResultTab'])
  },
  computed: {
    tabs () {
      switch (this.tabsType) {
        case 'check': {
          return [
            { displayText: this.$t('Persona'), value: 'person' },
            { displayText: this.$t('Conductor & vehículo'), value: 'vehicle' },
            { displayText: this.$t('Empresas'), value: 'company' }
          ]
        }
        case 'result': {
          return [
            { displayText: this.$t('Puntaje'), value: 'score' },
            { displayText: this.$t('Detalles'), value: 'details' }
          ]
        }
      }
      return []
    },
    style () {
      if (this.tabsType === 'result') {
        return {
          '--c-tabs-not-active': 'rgb(186,159,255)'
        }
      }
      return {
        '--c-tabs-not-active': 'rgba(0,0,0,.54)'
      }
    }
  },
  watch: {
    tab () {
      switch (this.tabsType) {
        case 'check': {
          const checkType = ((this.tabs as any)[(this.tab as any)].value) as string
          (this.updateCheckType as Function)(checkType)
          break
        }
        case 'result': {
          (this.updateResultTab as Function)(this.tab)
          break
        }
      }
    }
  }
})
